var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{attrs:{"src":`https://swagger.restplay.net/`,"width":"100%","height":"800","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }